(() => {
  if (customElements.get('gcs-finish-selector')) return;
  let selectedFinish = 'natural-oak';
  try { selectedFinish = sessionStorage.getItem('gcs-vanity-finish') || selectedFinish; } catch (_) {}
  class FinishSelector extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const radios = [...this.querySelectorAll('input[type="radio"]')];
      const initial = radios.find(radio => radio.value === selectedFinish) || radios[0];
      if (initial) { initial.checked = true; this.update(initial); }
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"]')) this.update(event.target);
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
    update(radio) {
      selectedFinish = radio.value;
      try { sessionStorage.setItem('gcs-vanity-finish', selectedFinish); } catch (_) {}
      const scope = this.closest('product-info') || document;
      const image = scope.querySelector('[data-gcs-finish-image]');
      if (image) {
        image.src = radio.dataset.render;
        image.alt = 'Custom 2 drawer floating Bathroom Vanity — ' + radio.dataset.finishName;
      }
      this.querySelector('[data-gcs-finish-name]').textContent = radio.dataset.finishName;
      const caption = scope.querySelector('[data-gcs-finish-caption]');
      if (caption) caption.textContent = radio.dataset.finishName;
    }
  }
  customElements.define('gcs-finish-selector', FinishSelector);
  // These are visual draft options, not live Shopify variant IDs.
  document.addEventListener('submit', event => {
    if (event.target.closest('.gcs-finish-preview') && event.target.matches('form[action*="/cart/add"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
